import { createTheme, adaptV4Theme } from '@mui/material/styles';
import {
  blueLight,
  ctaOrange,
  errorRed,
  flexeBlue,
  grayDark,
  grayLighter,
  grayMedDark,
  grayMedLight,
  white,
} from './flexeColors';

const flexeTheme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        main: flexeBlue,
      },
      secondary: {
        main: grayLighter,
      },
    },
    overrides: {
      MuiButton: {
        root: {
          marginRight: '15px',
        },
      },
      MuiDialogContent: {
        root: {
          overflowY: 'auto',
        },
      },
      MuiFormControl: {
        root: {
          width: '100%',
          margin: '5px 0',
        },
      },
      MuiFormControlLabel: {
        root: {
          width: '100%',
          margin: '5px 0',
        },
      },
      MuiToolbar: {
        root: {
          minHeight: 56,
          backgroundColor: grayDark,
          justifyContent: 'space-between',
        },
      },
      MuiDivider: {
        root: {
          backgroundColor: grayMedDark,
          display: 'block',
          height: 32,
          marginLeft: 24,
          width: 1,
        },
      },
      MuiRadio: {
        root: {
          padding: 0,
          marginRight: 16,
        },
      },
      MuiDialog: {
        paper: {
          padding: 24,
        },
      },
    },
  }),
);

export default flexeTheme;
